export * from "./generic-table.component";
export * from "./generic-table.service";
export * from "./generic-table.module";
export * from "./models";
